import React from "react";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="addressmap">
        <div className="form">
          <ContactForm />
        </div>
      </div>
      {/* <div className="zero">
      <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3480.2664059257136!2d88.60116699999999!3d27.3167331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6a500fffffffd%3A0x4f44f3b484a3649!2sMEVEDIR!5e1!3m2!1sen!2sin!4v1741774195627!5m2!1sen!2sin"  
          allowfullscreen=""
          style={{ display: 'block', verticalAlign: 'bottom' }}
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div> */}
      <div className="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3480.2664059257136!2d88.60116699999999!3d27.3167331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6a500fffffffd%3A0x4f44f3b484a3649!2sMEVEDIR!5e1!3m2!1sen!2sin!4v1741774195627!5m2!1sen!2sin"  
          allowfullscreen=""
          loading="lazy"
          style={{ display: 'block', verticalAlign: 'bottom' }}
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
